import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { trackEvent } from "@/lib/api";

export default function AbogadosTexcoco() {
  useEffect(() => {
    trackEvent("legacy_redirect", { origen: "abogados-texcoco" });
  }, []);
  return <Navigate to="/nosotros" replace />;
}
